export const LANGUAGES = [
  { code: "en", name: "English", native: "English", dir: "ltr", typingUrl: "" },
  { code: "hi", name: "Hindi", native: "हिन्दी", dir: "ltr", typingUrl: "https://www.easyhindityping.com/" },
  { code: "mr", name: "Marathi", native: "मराठी", dir: "ltr", typingUrl: "https://www.englishtomarathityping.com/" },
  { code: "gu", name: "Gujarati", native: "ગુજરાતી", dir: "ltr", typingUrl: "https://www.easygujaratityping.com/" },
  { code: "ta", name: "Tamil", native: "தமிழ்", dir: "ltr", typingUrl: "https://www.easytamiltyping.com/" },
  { code: "bn", name: "Bengali", native: "বাংলা", dir: "ltr", typingUrl: "https://www.easybengalityping.com/" },
  { code: "ml", name: "Malayalam", native: "മലയാളം", dir: "ltr", typingUrl: "https://www.easymalayalamtyping.com/" },
  { code: "te", name: "Telugu", native: "తెలుగు", dir: "ltr", typingUrl: "https://www.easytelugutyping.com/" },
  { code: "ur", name: "Urdu", native: "اردو", dir: "rtl", typingUrl: "https://www.easyurdutyping.com/" },
  { code: "pa", name: "Punjabi", native: "ਪੰਜਾਬੀ", dir: "ltr", typingUrl: "https://www.easypunjabityping.com/" },
];

const BY_CODE = Object.fromEntries(LANGUAGES.map((l) => [l.code, l]));

export function normalizeLang(code) {
  const c = String(code || "en").toLowerCase();
  return BY_CODE[c] ? c : "en";
}

export function langMeta(code) {
  return BY_CODE[normalizeLang(code)];
}

export function youtubeEmbed(url) {
  const m = String(url || "").match(/(?:youtu\.be\/|youtube\.com\/(?:watch\?v=|embed\/|shorts\/))([\w-]{11})/);
  return m ? `https://www.youtube.com/embed/${m[1]}` : "";
}
